import { ContentObjectLink } from './ContentObjectLink'

export * from './ContentObjectLink'

export default ContentObjectLink